import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { Utils } from 'src/app/shared/helpers/utils.helper';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment';
import { LoginOTPDTO } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { UserService } from 'src/app/shared/services/user.service';
import { lastValueFrom } from 'rxjs';
import en from 'src/assets/i18n/en';  
import { FormValidationService } from 'src/app/shared/services/form-validation.service'; 
import { VendorService } from 'src/app/shared/services/vendor.service';

import { AuthenticationActions } from 'src/app/modules/authentication/components/models/authentication-actions.enum';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['../../../authentication/components/authentication/authentication.component.scss'] 
})
export class OtpComponent implements OnInit, OnDestroy {
  private _otpForm: FormGroup;
  isSubmitting: boolean = false;
  verifyEmailPage: boolean = false;
  otpError: string | null = null;
  email: string | null;
  mobile: string | null;
  data: any | null;
  action: AuthenticationActions;
  resendSuccess: boolean = false;
  resendError: boolean = false;
  resendSuccessMessage: string = "A new OTP has been sent to your email and mobile number.";
  resendErrorMessage: string = "There was an error resending the OTP. Please try again.";
  resendTimer: number = 0; // Timer in seconds
  resendTimerInterval: any; // Interval reference
  readonly RESEND_COOLDOWN = 60; // 60 seconds cooldown


  //#region getters
  public get otpForm(): FormGroup {
    return this._otpForm;
  }
  //#endregion

  //#region setters
  public set otpForm(value: FormGroup) {
    this._otpForm = value;
  }
  //#endregion


  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private vendorService: VendorService,
    private toastService: ToastService
    ) {}

  ngOnInit(): void {

    

    

    this.verifyEmailPage = false;



    this._activeRoute.queryParams.subscribe(params => {
      this.action = +params['action']; // '+' converts the string to a number
      console.log('Action:', this.action);

      if(this.action == AuthenticationActions.VerifyEmail) {
        this.verifyEmailPage = true;
      }

      if(this.action == AuthenticationActions.Login || this.action == AuthenticationActions.ForgetPassword) {
        this.email = this._userService.email;
        // Get mobile from user data if available
        this.mobile = this._userService.user?.MobilePhone || null;
  
        if (!this.email) {
          // Redirect back to login if email is not set
           this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
    
        }
      }

      if(this.action == AuthenticationActions.Register) {
        this.data = this._userService.getRegistrationData();
        this.email = this.data?.Email || null;
        this.mobile = this.data?.mobile || null;

        if (!this.email ) {
          // Redirect back to login if email is not set
           this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
    
        }
      }


    });
    
    this.otpForm = this.fb.group({
      otp1: [environment.DISABLE_BACKEND ? '1' : '', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp2: [environment.DISABLE_BACKEND ? '2' : '', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp3: [environment.DISABLE_BACKEND ? '3' : '', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]],
      otp4: [environment.DISABLE_BACKEND ? '4' : '', [Validators.required, Validators.minLength(1), Validators.maxLength(1)]]
    });

    // Start timer automatically when page loads
    this.startResendTimer();
  }

  // Allow only numeric input - professional solution
  onOtpKeyPress(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Allow only numbers (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  // Additional input validation to prevent paste of non-numeric characters
  onOtpInput(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    // Remove any non-numeric characters
    const numericValue = value.replace(/[^0-9]/g, '');
    if (value !== numericValue) {
      this.otpForm.get(controlName)?.setValue(numericValue);
    }
  }

  onSubmit() {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;

    if (this.otpForm.invalid) {
      this.markFormGroupTouched(this.otpForm);
     // this.setCustomErrors();
      this.isSubmitting = false;
      return;
    }

    const otp = `${this.otpForm.value.otp1}${this.otpForm.value.otp2}${this.otpForm.value.otp3}${this.otpForm.value.otp4}`;
    this.verifyOtp(otp);
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }



  //this.formValidationService.setCustomError(this.otpForm.get('otp1'), errorMessage);

  private verifyOtp(otp: string) {
    // Implement OTP verification logic here
    console.log('OTP submitted:', otp);
    
    const loginOTPDTO = new LoginOTPDTO(this._userService.email, otp,this.action);

    this.handleOTPVerfication(loginOTPDTO);

    // Simulate OTP verification
    // setTimeout(() => {
    //   if (otp === '1234') { // Example OTP
    //     this.router.navigate(['/home']); // Navigate to home page on success
    //   } else {
    //     this.otpError = 'Invalid OTP. Please try again.';
    //     this.isSubmitting = false;
    //   }
    // }, 1000); 
  }


  async resendOTP() {
    // Prevent resend if timer is active
    if (this.resendTimer > 0) {
      return;
    }

    this._loaderService.showLoader(); // Show loader during the API call
    const apiService = this.createApiService();
    var payload ;
    if (this.action == AuthenticationActions.Login || this.action == AuthenticationActions.ForgetPassword) {
        payload = {
          Email: this.email,
          action: this.action
        };
    } else {
      // Prepare the payload (email and mobile) for the resend OTP request
      payload = {
        Email: this.data.Email,
        Mobile: this.data.mobile,
        action: this.action
      };
    }

    // Call the API to resend the OTP
    this.fireResendOTPRequest(apiService, payload)
      .then((response: any) => {
        let result = response as unknown as BaseResponseDTO;
        if (result.isSuccess) {
          this.toastService.success('A new OTP has been sent to your email and mobile number.'); 
          // Start the timer
          this.startResendTimer();
        } else {
          this.toastService.error(result.errorMessageEn); 
        }
      })
      .catch((err: HttpErrorResponse) => {
        this._loaderService.hideLoader();
        this.toastService.error('Failed to resend OTP.'); 
        console.error('Error resending OTP:', err);
      })
      .finally(() => {
        this._loaderService.hideLoader(); // Hide the loader after the API call completes
      });
  }

  startResendTimer() {
    this.resendTimer = this.RESEND_COOLDOWN;
    this.resendTimerInterval = setInterval(() => {
      if (--this.resendTimer <= 0) {
        clearInterval(this.resendTimerInterval);
        this.resendTimer = 0;
      }
    }, 1000);
  }

  ngOnDestroy() {
    if (this.resendTimerInterval) {
      clearInterval(this.resendTimerInterval);
    }
  }
  

  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
    return apiService;
  }

  private async handleOTPVerfication(data: LoginOTPDTO) {
    this._loaderService.showLoader();
    const apiService = this.createApiService();
    const payload = this.prepareValidateOTPRequestPayload(data);
    this.fireValidateUserRequest(apiService, payload)
    .then((response: any) => {
      let result = response as unknown as BaseResponseDTO;
      if(result.isSuccess) {
        if (this.action === AuthenticationActions.ForgetPassword) {
          this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.CHANGE_PASS]);
        } else if (this.action === AuthenticationActions.Login) {
          this._userService.handleValidAuthentication(result);
          this._router.navigate([AppConstants.ROUTES.HOME]);
        } else if (this.action === AuthenticationActions.Register) {

          this.vendorService.createVendor(data.OTP);
        }

        if(Utils.IsNullOrWhiteSpace(this._userService.user?.Id)) {
          //this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.REGISTER])
          // location.href="authentication/introduction";
        } else {
   

    
        }
      } else {
        this.otpError = result.errorMessageEn;
      }
    })
    .catch((err: HttpErrorResponse) => {
      this._loaderService.hideLoader();
     

    })
    .finally(() => {
      this._loaderService.hideLoader();
      this.isSubmitting = false;
    });
  }

  resendEmail() {
    console.log('Resending email...');
  }

   //#region Payloads
  private prepareValidateOTPRequestPayload(data: any) {
    return data as LoginOTPDTO;
  }
  //#endregion

  private fireValidateUserRequest(apiService: ApiService, payload: LoginOTPDTO) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.ACCOUNT, AppConstants.ACTIONS.VerifyOTP, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }

  private fireResendOTPRequest(apiService: ApiService, payload: { Email: string; Mobile: string }) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.ACCOUNT, AppConstants.ACTIONS.Generateotp, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$); // Convert observable to a promise
  }

  

}
